import { UserRound } from "lucide-react";
import React from "react";

const NOVA = "__nova__";

// "Para quem" de cada produto no carrinho do garçom (dono, 24/09/2026). O
// produto fica na comanda da pessoa escolhida, marcado "lançado pelo garçom";
// "Mesa" é o lançamento sem dono (só entra no "pagar a mesa toda" ou no caixa).
// "+ Nova pessoa" cria alguém que não tem celular ou dividiu o celular.
export default function SeletorPessoa({ valor, pessoas, podeCriar, onEscolher, onNova }) {
  const presentes = (pessoas || []).filter((p) => !p.saiu);

  const mudar = (e) => {
    const v = e.target.value;
    if (v === NOVA) return onNova();
    if (!v) return onEscolher(null, null);
    const p = presentes.find((x) => x.cliente_id === v);
    return onEscolher(v, p?.primeiro_nome || p?.nome || null);
  };

  return (
    <label className="flex items-center gap-2 text-xs text-muted-foreground -mt-1 px-1" data-e2e="seletor-pessoa">
      <UserRound className="w-3.5 h-3.5 shrink-0" />
      <span>Para</span>
      <select
        value={valor || ""}
        onChange={mudar}
        className="flex-1 min-w-0 h-8 rounded-lg border bg-background text-foreground text-xs font-semibold px-2"
      >
        <option value="">Mesa (sem dono)</option>
        {presentes.map((p) => (
          <option key={p.cliente_id} value={p.cliente_id}>
            {p.nome}{p.origem === "painel" ? " (sem celular)" : ""}
          </option>
        ))}
        {podeCriar ? <option value={NOVA}>+ Nova pessoa…</option> : null}
      </select>
    </label>
  );
}
